import resourceTypes, { ResourceTypes } from './resourceTypes';

// Resource types whose documents are never created or changed by a direct Member
// action (purely system-computed, or machine-to-machine credentials). Excluded by
// default from the global audit trail list, since they carry no compliance value there.
// Mirrors api/src/constants/internalResourceTypes.ts.
const internalResourceTypes: ResourceTypes[] = [
  resourceTypes.CASE_TRANSACTION_SNAPSHOT,
  resourceTypes.CONNECTION,
  resourceTypes.DATA_POINT,
  resourceTypes.SERVICE,
];

export default internalResourceTypes;
